<template lang="html">
  <div>
    <form :action="facebookLink" method="post">
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <button
        v-click-track="{ action_type: 'login' }"
        :disabled="!facebookLink"
        class="button social-login social-login__facebook with-icon-before with-icon-large expanded"
      >
        <svg-icon
          class="fsd-session__button-icon"
          icon-name="facebook-inverted"
        />
        <span>{{ 'client.registration.buttons.facebook' | t }}</span>
      </button>
    </form>
    <form :action="googleLink" method="post">
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <button
        v-click-track="{ action_type: 'login' }"
        :disabled="!googleLink"
        type="submit"
        class="button social-login social-login__google with-icon-before with-icon-large expanded"
      >
        <svg-icon class="fsd-session__button-icon" icon-name="google" />
        <span>{{ 'client.registration.buttons.google' | t }}</span>
      </button>
    </form>
  </div>
</template>

<script>
import _get from 'lodash-es/get'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    searchProfile: { type: Object, default: null },
    rc: { type: String, default: '' }
  },
  computed: {
    ...mapState([
      'initialIntent',
      'initialIntentData',
      'hasSponsoredMailingOptIn',
      'csrfToken',
      'optInConsentHint',
      'sponsoredMailingOptInConsentHint',
      'links'
    ]),
    oauthLinkWatcher() {
      return [
        this.initialIntent,
        this.initialIntentData,
        this.hasSponsoredMailingOptIn,
        this.rc,
        _get(this.searchProfile, 'q'),
        _get(this.searchProfile, 'code'),
        _get(this.searchProfile, 'name'),
        _get(this.searchProfile, 'isActive'),
        _get(this.optInConsentHint, 'id'),
        (_get(this.searchProfile, 'customTags') || []).join(),
        (_get(this.searchProfile, 'tagKeys') || []).join()
      ].join()
    },
    googleLink() {
      return _get(this.links, 'oauthOrigins.google')
    },
    facebookLink() {
      return _get(this.links, 'oauthOrigins.facebook')
    }
  },
  watch: {
    oauthLinkWatcher() {
      this.fetchLinks()
    }
  },
  mounted() {
    this.fetchLinks()
  },
  methods: {
    ...mapActions(['oauthPaths']),
    fetchLinks() {
      this.oauthDisabled = false
      this.oauthPaths({
        intent: this.initialIntent,
        intentData: this.initialIntentData,
        sponsoredMailingOptInConsentHintId: this.hasSponsoredMailingOptIn
          ? _get(this.sponsoredMailingOptInConsentHint, 'id')
          : null,
        optInConsentHintId: _get(this.optInConsentHint, 'id'),
        rc: this.rc,
        customTags: _get(this.searchProfile, 'customTags'),
        categoryTags: _get(this.searchProfile, 'tagKeys'),
        q: _get(this.searchProfile, 'q'),
        code: _get(this.searchProfile, 'code'),
        name: _get(this.searchProfile, 'name'),
        isActive: _get(this.searchProfile, 'isActive')
      })
    }
  }
}
</script>
